import React from 'react';
import {
  Card,
  Row,
  Col,
  Input,
  Upload,
  Button,
  Typography,
  Select,
  message,
} from 'antd';

import {
  UploadOutlined,
  DeleteOutlined,
} from '@ant-design/icons';

import CharacterImage from "../../components/CharacterImage";

const { Text } = Typography;

const CharacterCard = ({
  character,
  index,
  characterImages,
  handleCharacterInputChange,
  handleColorChange,
  handleCharacterImageChange,
  handleRemoveCharacter,
  COLOR_OPTIONS,
  getBrightness,
  storyId,
  requestCharacterDelete,
  actors = [],
}) => {

  return (
    <Card key={index} style={{ marginBottom: "16px" }} bordered>
      <Row gutter={[16, 16]}>
        {/* Name */}
        <Col span={8}>
          <label
            className="writeLabel"
            htmlFor={`characterName${index}`}
          >
            Name des Charakters {index + 1}:
          </label>
          <Input
            className="writeArea"
            id={`characterName${index}`}
            name="name"
            value={character.name}
            onChange={(e) => handleCharacterInputChange(e, index)}
            required
            style={{ width: "100%" }}
          />
        </Col>



        <Col span={8}>
  <label className="writeLabel">
    Actor
  </label>

  <Select
    style={{
      width: "100%",
    }}
    placeholder="Actor auswählen"
    value={character.actor_id ?? undefined}
    allowClear
    onChange={(value) =>
      handleCharacterInputChange(
        {
          target: {
            name: "actor_id",
            value: value ?? null,
          },
        },
        index
      )
    }
  >
    {actors.map((actor) => (
      <Select.Option
        key={actor.id}
        value={actor.id}
      >
        {actor.name}
      </Select.Option>
    ))}
  </Select>
</Col>





        <Col span={8}>
          <label className="writeLabel">Farbe des Charakters TEST:</label>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: '8px',
              marginTop: '8px',
            }}
          >
            {COLOR_OPTIONS.map((color) => (
              <div
                key={color}
                onClick={() => handleColorChange(color, index)}
                style={{
                  width: '60%',
                  aspectRatio: '1',
                  backgroundColor: color,
                  borderRadius: '4px',
                  cursor: 'pointer',
                  border:
                    character.color === color
                      ? '4px solid black'
                      : '2px solid #ccc',
                }}
              />
            ))}
          </div>

          <Text
            style={{
              display: 'block',
              marginTop: '8px',
              backgroundColor: character.color,
              color:
                getBrightness(character.color) < 128
                  ? 'white'
                  : 'black',
              padding: '8px',
              borderRadius: '4px',
            }}
          >
            Vorschau
          </Text>
        </Col>



        <Col span={8}>
          <div
            style={{ display: "flex", flexDirection: "column" }}
          >
            <label
              className="writeLabel"
              htmlFor={`characterImage${index}`}
            >
              Bild des Charakters {index + 1}:
            </label>
            <Upload
              id={`characterImage${index}`}
              name="image"
              accept="image/png"
              showUploadList={false}
              beforeUpload={(file) => {
                const img = new Image();

                img.onload = () => {
                  URL.revokeObjectURL(img.src);
              
                  if (img.width > 50 || img.height > 50) {
                    message.error(
                      "Das Bild darf maximal 50 × 50 Pixel groß sein."
                    );
                    return;
                  }
              
                  handleCharacterImageChange(file, index);
                };
              
                img.src = URL.createObjectURL(file);
              
                return false;
              }}
            >
              <Button
                icon={
                  <UploadOutlined style={{ fontSize: "24px" }} />
                }
                className="writeButton"
              >
                Bild hochladen
              </Button>
            </Upload>

            {character.localImageFile ? (
              <img
                src={URL.createObjectURL(
                  character.localImageFile
                )}
                alt={`Bild von Charakter ${index + 1}`}
                style={{
                  marginTop: "8px",
                  maxWidth: "50px",
                  maxHeight: "50px",
                  width: "auto",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            ) : (
              <CharacterImage
                filename={character.img}
                name={character.name}
                storyId={storyId}
                src="pubup"
              />
            )}
          </div>
        </Col>

      </Row>

      <Button
        icon={<DeleteOutlined />}
        className="removeButton"
        onClick={() => requestCharacterDelete(character)}
      >
        Entfernen
      </Button>

    </Card>
  );
};

export default CharacterCard;